import { ERROR_DEFAULT } from 'app/shared/consts/error-codes';
import { MessageFormatElement } from 'react-intl';

import { getTranslationKey } from 'app/shared/utils/get-translation-key';
import { ERROR_TRANSLATION_PREFIX, ErrorType, ERROR_TRANSLATION_TITLE_SUFFIX, ERROR_TRANSLATION_DESCRIPTION_SUFFIX, ERROR_TRANSLATION_BUTTON_TEXT_SUFFIX } from 'app/shared/consts/error-translations';
import { ErrorNotification } from 'app/shared/types/errors.types';

interface ErrorDetails {
  errorCode: string;
  titleTranslationId: string;
  descriptionTranslationId: string;
  buttonTextTranslationId: string;
}

function getTranslationPrefix(errorType: ErrorType, errorCode: string): string {
  return getTranslationKey(ERROR_TRANSLATION_PREFIX, errorType, errorCode);
}

export function getErrorDetails(
  errors: Pick<ErrorNotification, 'errorCode'>[],
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
  errorType: ErrorType,
): ErrorDetails {
  const errorCode = errors[0]?.errorCode?.toLowerCase();
  const errorTranslationPrefix = getTranslationPrefix(errorType, errorCode);
  const hasTranslationForErrorCode = Object.prototype.hasOwnProperty.call(
    messages,
    getTranslationKey(errorTranslationPrefix, ERROR_TRANSLATION_TITLE_SUFFIX),
  );
  const translationPrefix = hasTranslationForErrorCode
    ? errorTranslationPrefix
    : getTranslationPrefix(errorType, ERROR_DEFAULT);

  return {
    errorCode: hasTranslationForErrorCode ? errorCode : ERROR_DEFAULT,
    titleTranslationId: getTranslationKey(translationPrefix, ERROR_TRANSLATION_TITLE_SUFFIX),
    descriptionTranslationId: getTranslationKey(translationPrefix, ERROR_TRANSLATION_DESCRIPTION_SUFFIX),
    buttonTextTranslationId: getTranslationKey(translationPrefix, ERROR_TRANSLATION_BUTTON_TEXT_SUFFIX),
  };
}
